.hello_class {
    color: red;
    background: grey;
}